import { Helmet } from 'react-helmet-async';
// sections
import { RecentlyAddedView } from 'src/sections/recently-added/view';

// ----------------------------------------------------------------------

export default function OverviewAppPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Recently Added</title>
      </Helmet>

      <RecentlyAddedView />
    </>
  );
}
